export default __webpack_public_path__ + "static/media/1Y.4881d6f5.png";